import { useTranslation } from 'react-i18next';
import { SafeLink } from '../components/SafeLink.tsx';
import { usePageTitle } from '../lib/format.ts';
import { useRouter } from '../lib/router.tsx';

/**
 * After sign-out (roadmap 3.4). Signing out of MDT does not sign the browser out of Google, so on a
 * shared computer the next person could otherwise continue as this person in any Google service: this
 * screen offers Google's own sign-out and says to close the browser.
 */
export function SignedOut() {
  const { t } = useTranslation();
  const { search } = useRouter();
  const reason = search.get('reason');
  const shared = search.get('mode') === 'shared';
  const title = reason === 'idle' ? t('signedOut.idleTitle') : reason === 'expired' ? t('signedOut.expiredTitle') : t('signedOut.title');
  usePageTitle(title);
  return (
    <div className="stack">
      <h1>{title}</h1>
      <p>{shared ? t('signedOut.sharedWiped') : t('signedOut.body')}</p>
      {shared ? (
        <section className="card card--emphasis" aria-labelledby="google-signout">
          <h2 id="google-signout">{t('signedOut.googleTitle')}</h2>
          <p>{t('signedOut.googleBody')}</p>
          <SafeLink sameTab className="btn" href="https://accounts.google.com/Logout">{t('signedOut.googleButton')}</SafeLink>
          <p className="muted small">{t('signedOut.closeBrowser')}</p>
        </section>
      ) : null}
      <p><SafeLink href="/login" className="btn btn--secondary">{t('signedOut.signInAgain')}</SafeLink></p>
    </div>
  );
}
